import React from "react";
import ReusableDropdown from "../../../../components/ReusableDropdown";
import ReusableMultiSelect from "../../../../components/ReusableMultiSelect";

/**
 * "Specific / Multiple / All" picker for Employee and Company filters.
 * value shape: { mode: "all" | "specific" | "multiple", ids: string[] }
 * ("specific" stores a single id in ids[0] so the shape stays uniform).
 */
const ScopedEntityFilter = ({ value, onChange, list, theme, isRTL, language, text, loading }) => {
  const isDark = theme === "dark";
  const mode = value?.mode || "all";
  const ids = value?.ids || [];

  const setMode = (nextMode) => onChange({ mode: nextMode, ids: nextMode === mode ? ids : [] });

  const dropdownInputStyle = {
    width: "100%", padding: "9px 12px", borderRadius: 10,
    border: `1px solid ${isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)"}`,
    background: isDark ? "rgba(255,255,255,0.05)" : "#fff",
    color: isDark ? "#f1f5f9" : "#1e293b", fontSize: 13,
    textAlign: isRTL ? "right" : "left", boxSizing: "border-box",
  };

  const modes = [
    ["all", text.filterModeAll], ["specific", text.filterModeSpecific], ["multiple", text.filterModeMultiple],
  ];

  return (
    <div>
      <div style={{ display: "flex", borderRadius: 10, overflow: "hidden", border: `1px solid ${isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)"}`, marginBottom: 8 }}>
        {modes.map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setMode(key)}
            style={{
              flex: 1, padding: "6px 0", border: "none", cursor: "pointer", fontSize: 11, fontWeight: 700,
              background: mode === key ? "#3b82f6" : "transparent",
              color: mode === key ? "#fff" : (isDark ? "#94a3b8" : "#64748b"),
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {mode === "specific" && (
        <ReusableDropdown
          items={list}
          value={ids[0] || ""}
          onChange={(key) => onChange({ mode, ids: key ? [key] : [] })}
          getItemKey={(it) => it.key}
          getItemLabel={(it) => it.label}
          placeholder={loading ? text.loading : text.filterAll}
          disabled={loading}
          theme={theme}
          language={language}
          maxItems={8}
          showAllOnArrowClick
          inputStyle={dropdownInputStyle}
        />
      )}

      {mode === "multiple" && (
        <ReusableMultiSelect
          items={list}
          selectedIds={ids}
          onChange={(nextIds) => onChange({ mode, ids: nextIds })}
          getItemKey={(it) => it.key}
          getItemLabel={(it) => it.label}
          placeholder={loading ? text.loading : text.filterAll}
          disabled={loading}
          theme={theme}
          language={language}
          maxItems={8}
          showAllOnArrowClick
          inputStyle={dropdownInputStyle}
        />
      )}
    </div>
  );
};

export default ScopedEntityFilter;
